import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppViewer } from '../components/AppViewer/AppViewer';
import { GraphicsPanel } from '../components/GraphicsPanel/GraphicsPanel';
import { useStyleFromUrl, useViewerControlsFromUrl, useUnitsFromUrl, useShowGraphicsPanelFromUrl, useIdleAnimationModeFromUrl, } from './StyleViewerPage.hooks';
const PageLayout = styled.div `
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
export const StyleViewerPage = () => {
    const { isMockupMode, useBrandLogos } = useStyleFromUrl();
    const { controlsLayout, controlsStyle } = useViewerControlsFromUrl();
    const sceneIsLoading = useSelector((state) => state.app.sceneIsLoading);
    const styleRegions = useSelector((state) => state.app.styleRegions);
    const units = useUnitsFromUrl();
    const showGraphicsPanel = useShowGraphicsPanelFromUrl();
    const idleAnimationMode = useIdleAnimationModeFromUrl();
    const blockBrandLogoRegions = isMockupMode && useBrandLogos;
    const effectiveUseBrandLogos = isMockupMode ? useBrandLogos : true;
    const editableRegions = useMemo(() => {
        if (!blockBrandLogoRegions) {
            return styleRegions;
        }
        return styleRegions.filter(region => !region.isBrandLogoRegion);
    }, [blockBrandLogoRegions, styleRegions]);
    return (_jsxs(PageLayout, { children: [_jsx(AppViewer, { controlsLayout: controlsLayout, controlsStyle: controlsStyle, idleAnimationMode: idleAnimationMode, showGraphicsPanel: showGraphicsPanel, useBrandLogos: effectiveUseBrandLogos }), showGraphicsPanel && (_jsx(GraphicsPanel, { disabled: sceneIsLoading || editableRegions.length === 0, units: units, editableRegions: editableRegions, blockBrandLogoRegions: blockBrandLogoRegions }))] }));
};
